import { ROUTES } from "@/routes_new";
import { Organization } from "@/types/Organization";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbLink,
  BreadcrumbPage,
} from "@components/ui/breadcrumb";
import { Button } from "@components/ui/button";
import { Separator } from "@components/ui/separator";
import { SidebarTrigger } from "@components/ui/sidebar";
import { Trans } from "@lingui/react/macro";
import { ArrowRightIcon } from "lucide-react";
import { generatePath, Link, useRouteMatch } from "react-router-dom";
import { PreviewFormSubmitButton } from "./types";

type HeaderProps = {
  orgUuid: Organization["uuid"];
};

export default function Header({ orgUuid }: HeaderProps) {
  const isOnPreview = useRouteMatch(ROUTES.SEARCH_PREVIEW_ORGID);

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6 max-w-(--site-content-max-width)">
        <SidebarTrigger className="-ml-1" />

        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />

        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link
                  to={generatePath(ROUTES.SEARCH_ORGID, {
                    orgUuid,
                  })}
                >
                  <Trans>Sök</Trans>
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            {isOnPreview && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>
                    <Trans>Förhandsgranska</Trans>
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </>
            )}
          </BreadcrumbList>
        </Breadcrumb>

        {isOnPreview && (
          <>
            <button
              name={PreviewFormSubmitButton.Preview}
              form="search-preview-form"
              className="sr-only"
              tabIndex={-1}
              aria-hidden
              type="submit"
            />

            <Button
              name={PreviewFormSubmitButton.Create}
              form="search-preview-form"
              className="ml-auto"
              type="submit"
              id="form-qb-create"
              data-testid="follow-button"
            >
              <Trans>Fortsätt</Trans>
              <ArrowRightIcon />
            </Button>
          </>
        )}
      </div>
    </header>
  );
}
